/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse {
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    familySerialNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    familyNameKana?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    firstNameKana?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    age?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    customerNo?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    menuBasicInfo?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    planBasicInfo?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    payMthdInfo?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfo;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    cautions?: Array<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution>;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    grantedBenepo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    canSubsidy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    canSubsidyRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    canCafePoint?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    orderSite?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    orderSubsidyFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    orderCafeFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    orderBenepoFlag?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    orderPayFlag?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    subsidyRequiredAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    subsidyNoRequiredAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    benepoAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    cafeUsePoint?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    subTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    subsidyAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    billingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    canUsePoint?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    trySubsidyTransactionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    doneApplySubsidy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    doneApplyCafe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse
     */
    contractCafe?: boolean;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'familySerialNumber': !exists(json, 'familySerialNumber') ? undefined : json['familySerialNumber'],
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'familyNameKana': !exists(json, 'familyNameKana') ? undefined : json['familyNameKana'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'firstNameKana': !exists(json, 'firstNameKana') ? undefined : json['firstNameKana'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'customerNo': !exists(json, 'customerNo') ? undefined : json['customerNo'],
        'menuBasicInfo': !exists(json, 'menuBasicInfo') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoFromJSON(json['menuBasicInfo']),
        'planBasicInfo': !exists(json, 'planBasicInfo') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoFromJSON(json['planBasicInfo']),
        'payMthdInfo': !exists(json, 'payMthdInfo') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoFromJSON(json['payMthdInfo']),
        'cautions': !exists(json, 'cautions') ? undefined : ((json['cautions'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionFromJSON)),
        'grantedBenepo': !exists(json, 'grantedBenepo') ? undefined : json['grantedBenepo'],
        'canSubsidy': !exists(json, 'canSubsidy') ? undefined : json['canSubsidy'],
        'canSubsidyRequired': !exists(json, 'canSubsidyRequired') ? undefined : json['canSubsidyRequired'],
        'canCafePoint': !exists(json, 'canCafePoint') ? undefined : json['canCafePoint'],
        'orderSite': !exists(json, 'orderSite') ? undefined : json['orderSite'],
        'orderSubsidyFlag': !exists(json, 'orderSubsidyFlag') ? undefined : json['orderSubsidyFlag'],
        'orderCafeFlag': !exists(json, 'orderCafeFlag') ? undefined : json['orderCafeFlag'],
        'orderBenepoFlag': !exists(json, 'orderBenepoFlag') ? undefined : json['orderBenepoFlag'],
        'orderPayFlag': !exists(json, 'orderPayFlag') ? undefined : json['orderPayFlag'],
        'subsidyRequiredAmountTotal': !exists(json, 'subsidyRequiredAmountTotal') ? undefined : json['subsidyRequiredAmountTotal'],
        'subsidyNoRequiredAmountTotal': !exists(json, 'subsidyNoRequiredAmountTotal') ? undefined : json['subsidyNoRequiredAmountTotal'],
        'benepoAmountTotal': !exists(json, 'benepoAmountTotal') ? undefined : json['benepoAmountTotal'],
        'cafeUsePoint': !exists(json, 'cafeUsePoint') ? undefined : json['cafeUsePoint'],
        'subTotal': !exists(json, 'subTotal') ? undefined : json['subTotal'],
        'subsidyAmountTotal': !exists(json, 'subsidyAmountTotal') ? undefined : json['subsidyAmountTotal'],
        'billingAmount': !exists(json, 'billingAmount') ? undefined : json['billingAmount'],
        'canUsePoint': !exists(json, 'canUsePoint') ? undefined : json['canUsePoint'],
        'trySubsidyTransactionId': !exists(json, 'trySubsidyTransactionId') ? undefined : json['trySubsidyTransactionId'],
        'doneApplySubsidy': !exists(json, 'doneApplySubsidy') ? undefined : json['doneApplySubsidy'],
        'doneApplyCafe': !exists(json, 'doneApplyCafe') ? undefined : json['doneApplyCafe'],
        'contractCafe': !exists(json, 'contractCafe') ? undefined : json['contractCafe'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'familySerialNumber': value.familySerialNumber,
        'familyName': value.familyName,
        'familyNameKana': value.familyNameKana,
        'firstName': value.firstName,
        'firstNameKana': value.firstNameKana,
        'age': value.age,
        'customerNo': value.customerNo,
        'menuBasicInfo': JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoToJSON(value.menuBasicInfo),
        'planBasicInfo': JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoToJSON(value.planBasicInfo),
        'payMthdInfo': JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoToJSON(value.payMthdInfo),
        'cautions': value.cautions === undefined ? undefined : ((value.cautions as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionToJSON)),
        'grantedBenepo': value.grantedBenepo,
        'canSubsidy': value.canSubsidy,
        'canSubsidyRequired': value.canSubsidyRequired,
        'canCafePoint': value.canCafePoint,
        'orderSite': value.orderSite,
        'orderSubsidyFlag': value.orderSubsidyFlag,
        'orderCafeFlag': value.orderCafeFlag,
        'orderBenepoFlag': value.orderBenepoFlag,
        'orderPayFlag': value.orderPayFlag,
        'subsidyRequiredAmountTotal': value.subsidyRequiredAmountTotal,
        'subsidyNoRequiredAmountTotal': value.subsidyNoRequiredAmountTotal,
        'benepoAmountTotal': value.benepoAmountTotal,
        'cafeUsePoint': value.cafeUsePoint,
        'subTotal': value.subTotal,
        'subsidyAmountTotal': value.subsidyAmountTotal,
        'billingAmount': value.billingAmount,
        'canUsePoint': value.canUsePoint,
        'trySubsidyTransactionId': value.trySubsidyTransactionId,
        'doneApplySubsidy': value.doneApplySubsidy,
        'doneApplyCafe': value.doneApplyCafe,
        'contractCafe': value.contractCafe,
    };
}

